import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import NotificationSystem from "react-notification-system";

import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";

import Loader from 'components/Loader'
import AccessDenied from 'components/AccessDenied'

import { UserAgentApplication } from 'msal';
import * as config from '../graph/Config.js';

import { isAdmin, isSuperAdmin } from '../components/Requests/Requests';
import { style } from "variables/Variables.jsx";
import { recordVisit } from "../config/visitTracker";

import repstorRoutes from "routes.jsx";

import image from "assets/img/rep1.jpg";

// Routes only super admins may see or open (hardcoded list in TokenService.cs)
const SUPER_ADMIN_PATHS = ["/admins"];

// Routes only admins may see or open (dbo.Admins in ConfigurationDb)
const ADMIN_PATHS = ["/workflows"];

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: "",
      authFailed: false,
      sessionExpired: false,
      image: image,
      hasImage: true,
      fixedClasses: "dropdown show-dropdown open",
      userAgentApplication: new UserAgentApplication(config.appId, "https://login.microsoftonline.com/" + config.tenantId, this.tokenReceived.bind(this), { redirectUri: window.location.origin + "/portal/dashboard" }),
      routes: repstorRoutes,
      fromRepstor: true,
      isAdmin: false,
      isSuperAdmin: false,
      rolesResolved: false,
    };
    this.login = this.login.bind(this);
  }

  // Routes with no entry in either list are open to any signed in user.
  canAccessRoute = (path) => {
    if (SUPER_ADMIN_PATHS.includes(path)) {
      return this.state.isSuperAdmin;
    }
    if (ADMIN_PATHS.includes(path)) {
      return this.state.isAdmin;
    }
    return true;
  };

  // Renders every route, not the role-filtered list in state: a gated route still needs a
  // Route registered so we can show the access denied screen instead of an empty panel.
  // state.routes stays filtered, which is what hides the entry from the sidebar.
  getRoutes = () => {
  return repstorRoutes.map((prop, key) => {
    if (prop.layout === "/portal") {
      return (
        <Route
          path={prop.layout + prop.path}
          render={props => {
            // Check if the route requires a role the user does not have
            if (!this.canAccessRoute(prop.path)) {
              // Wait for the role checks before denying, so a permitted user deep-linking
              // to a gated page is never shown a denial we are about to contradict
              return this.state.rolesResolved
                ? <AccessDenied history={props.history} />
                : <Loader />;
            }
            return (
              <prop.component 
                {...props} 
                handleClick={this.handleNotificationClick} 
                fromRepstor={this.state.fromRepstor} 
                accessToken={this.state.accessToken}
                userAgentApplication={this.state.userAgentApplication}
                routes={this.state.routes}
              />
            );
          }}
          key={key}
        />
      );
    } else {
      return null;
    }
  });
};

  handleImageClick = image => {
    this.setState({ image: image });
  };

  handleColorClick = color => {
    this.setState({ color: color });
  };

  handleHasImage = hasImage => {
    this.setState({ hasImage: hasImage });
  };

  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show-dropdown open" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };

  componentDidMount() {
    this._reauthenticating = false;
    this._handleTokenExpired = () => {
      if (this._reauthenticating) return;
      this._reauthenticating = true;
      this.setState({ accessToken: "", sessionExpired: true });
    };
    window.addEventListener('auth:token-expired', this._handleTokenExpired);
    setTimeout(() =>{
      this.login();
    });

  }

  componentWillUnmount() {
    window.removeEventListener('auth:token-expired', this._handleTokenExpired);
  }


  async login(){
    if(!this.state.accessToken){
      if(this.state.userAgentApplication.getUser()) {
        //User is already logged in but we don't have a token. Get the token
        this.getAccessToken();
      } else {
        try {
          await this.state.userAgentApplication.loginPopup(config.scopes);
          await this.getAccessToken();
        } catch (error) {
          console.error("Login failed:", error);
        }
      }
    }
  }

  async getAccessToken(){
    try {
      var accessToken = await this.state.userAgentApplication.acquireTokenSilent(config.scopes);
      this.setState({ accessToken: accessToken });
      await this.filterRoutesByRole();
    } catch (error) {
      console.log("Silent token acquisition failed, prompting login");
      try {
        var accessToken = await this.state.userAgentApplication.acquireTokenPopup(config.scopes);
        this.setState({ accessToken: accessToken });
        await this.filterRoutesByRole();
      } catch (popupError) {
        console.error("Re-authentication failed:", popupError);
        this.setState({ accessToken: "" });
      }
    }
  }

  tokenReceived(errorDesc, token, error, tokenType, userState){
    this.setState({
        accessToken: token
      });
  }


  componentDidUpdate(e) {
    if (this.props.location.pathname !== e.location.pathname) {
      recordVisit(this.props.location.pathname);
    }
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }

  // Reads a { "<flag>": true/false } role response, defaulting to no access.
  async readRoleFlag(requestRole, flag) {
    try {
      const response = await requestRole(this.state.accessToken);
      const text = await response.text();

      if (!text) {
        return false;
      }

      return JSON.parse(text)[flag] === true;
    } catch (error) {
      console.error("Role check failed:", error);
      return false;
    }
  }

  async filterRoutesByRole() {
    const [hasSuperAdminAccess, hasAdminAccess] = await Promise.all([
      this.readRoleFlag(isSuperAdmin, "isSuperAdmin"),
      this.readRoleFlag(isAdmin, "isAdmin"),
    ]);

    // Filter from the full route list so a re-auth can restore routes as well as remove them.
    const filtered = repstorRoutes.filter(r => {
      if (SUPER_ADMIN_PATHS.includes(r.path)) {
        return hasSuperAdminAccess;
      }
      if (ADMIN_PATHS.includes(r.path)) {
        return hasAdminAccess;
      }
      return true;
    });

    this.setState({
      routes: filtered,
      isSuperAdmin: hasSuperAdminAccess,
      isAdmin: hasAdminAccess,
      rolesResolved: true,
    });
  }

  render() {
    return (
      this.state.accessToken && !this.state.authFailed ?
      (<div className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Sidebar {...this.props} routes={this.state.routes} image={this.state.image}
        color={this.state.color}
        hasImage={this.state.hasImage}/>
        <div id="main-panel" className="main-panel" ref="mainPanel">
<Switch>{this.getRoutes()}</Switch>
          <Footer />
        </div>
      </div>)
      :
      (<div className="wrapper">
      <div style={{textAlign:'center'}} ref="mainPanel">
      {this.state.authFailed ? (
        <>
          <h2>We couldn't sign you in automatically.</h2>
          <p>This can happen if pop-up windows are blocked. Please click below to try again.</p>
          <button
            className="btn btn-primary btn-fill btn-wd"
            onClick={() => { this.setState({ authFailed: false }); this.login(); }}
          >
            Log In
          </button>
        </>
      ) : this.state.sessionExpired ? (
        <>
          <h2>Your session has timed out.</h2>
          <p>Your last action may not have completed. Please sign in and try again.</p>
          <button
            className="btn btn-primary btn-fill btn-wd"
            onClick={() => { this.setState({ sessionExpired: false }); this._reauthenticating = false; this.login(); }}
          >
            Sign Back In
          </button>
        </>
      ) : (
        <>
          <h2>Signing you in…</h2>
          <Loader/>
        </>
      )}
      </div>
    </div>)
    );
  }
}

export default Admin;
